<template>
  <div class="container-fluid">
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-help"></i> {{ $GetIsAnbohSaz() == "false" ? "پیگیری درخواست های وام" : "پیگیری درخواست های واحد" }}
          <span class="float-left" @click="$router.go(-1)">
            <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i
          ></span>
        </h6>
      </template>
      <template slot="content">
        <div class="container" :key="Render">
          <div v-if="NeedVamList.length > 0" class="row p-3">
            <div v-for="(item, index) in NeedVamList" :key="index" class="col-12 border mt-4 p-4 bnp-rounded border Netpa-Shadow">
              <span>کد رهگیری</span> <u class="font-weight-bold" style="font-size: 25px"> {{ item.codeRahgiri }}</u>
              <!-- <hr/> -->
              <div class="row mt-2">
                <div class="col-12 col-md-3">
                  <span class="text-secondary">{{ $GetIsAnbohSaz() == "false" ? "نوع تسهیلات" : "نوع قرارداد" }}: </span>
                  <span class="font-weight-bold">
                    {{ item.desNoe }}
                  </span>
                </div>
                <div class="col-12 col-md-2">
                  <span class="text-secondary">تاریخ درخواست : </span>
                  <span class="font-weight-bold">
                    {{ item.requestTarix }}
                  </span>
                </div>
                <div class="col-12 col-md-2">
                  <span class="text-secondary">{{ $GetIsAnbohSaz() == "false" ? "مبلغ تسهیلات" : "مبلغ قرارداد" }} : </span>
                  <span class="font-weight-bold">
                    {{ $Comma3ragham(item.mablagh) }}
                  </span>
                </div>
                <div class="col-12 col-md-3">
                  <span class="text-secondary">وضعیت تایید {{ $session.get("IsTaavoniEtebar") == true ? "تعاونی اعتبار" : "صندوق" }} : </span>
                  <span v-if="item.isModirTaeed == 0 && $session.get('CustCode') != '932' && $session.get('CustCode') != '8002'" class="badge badge-warning">
                    <i class="far fa-hourglass"></i> <i>در حال بررسی </i>
                  </span>
                  <span v-if="item.isModirTaeed == 1 && $session.get('CustCode') != '932' && $session.get('CustCode') != '8002'" class="badge badge-success">
                    <i class="fas fa-check"></i> <i>تایید شده</i>
                  </span>
                  <span v-if="item.isModirTaeed == 2 && $session.get('CustCode') != '932' && $session.get('CustCode') != '8002'" class="badge badge-danger">
                    <i class="fas fa-times"></i> <i>رد شده </i>
                  </span>
                  <span v-if="$session.get('CustCode') == '932' || $session.get('CustCode') == '8002'" class="p-1 font-weight-bold">
                    {{ item.wwwtblComboIdVaziyatGrp312Name }}
                  </span>
                </div>
                <div class="col-12 col-md-2">
                  <span class="text-secondary"> مدت باز پرداخت : </span>
                  <b class="text-danger font-weight-bold">
                    <u>{{ item.tedadGhest }}</u>
                  </b>
                  <span class="text-secondary mr-2">قسط</span>
                </div>

                <div class="col-12 col-md-3 mt-3">
                  <div class="" v-if="item.sepordeTime != null && item.sepordeTime != 0 && item.sepordeTime > 0">
                    <span class="text-secondary"> مدت سپرده گذاری : </span>
                    <b class="text-danger font-weight-bold">
                      <u>{{ item.sepordeTime }}</u>
                    </b>
                    <span class="mr-2 text-secondary">ماه</span>
                  </div>
                </div>
                <div class="col-12 col-md-7 mt-3"></div>
                <div class="col-12 col-md-2 mt-3 text-center">
                  <a @click="dropdown(index)" class="Pointer"> <i class="fas fa-chevron-circle-down text-primary"></i> مشاهده جزئیات </a>
                </div>
              </div>
              <span :id="'needBody' + index" class="NeedDropDown NoShow">
                <hr class="my-3" v-if="$session.get('CustCode') != 932" />
                <div class="row" v-if="$session.get('CustCode') != 932">
                  <!-- <div class="col-12">
                                            <span class="font-weight-bold"> وضعیت ضامنین</span>
                                        </div> -->

                  <div v-if="item.zamenName1 != null" class="col-12 col-md-4 border-right border-info">
                    <div v-if="item.zamenName1 == ''" class="row">
                      <span class="font-weight-bold"> برای ضامن اول اطلاعاتی وارد نشده است</span>
                    </div>
                    <div v-else class="row">
                      <div class="col-12 col-md-2 text-center" v-if="$session.get('CustCode') == '259' || $session.get('CustCode') == '8002'">
                        <span
                          class="fa fa-pen fa-2x mt-2 hover-dark Pointer text-secondary"
                          title="ویرایش ضامن اول"
                          @click="EditZamen(4031, item.id, item.zamenName1, item.isModirTaeed, item.zamenIsTaeed1)"
                        ></span>
                        <button type="button" class="d-none" id="ShowModal" data-toggle="modal" data-target="#Modal-light"></button>
                      </div>
                      <div class="col-12 col-md-10">
                        <div class="mb-1">
                          <span class="text-secondary">مشخصات ضامن اول: </span>
                          <span>{{ item.zamenName1 }}</span>
                        </div>
                        <span class="text-secondary">وضعیت تایید: </span>
                        <span v-if="item.zamenIsTaeed1 == 0" class="badge badge-warning"> <i class="far fa-hourglass"></i> <i>در حال بررسی </i> </span>
                        <span v-if="item.zamenIsTaeed1 == 1" class="badge badge-success"> <i class="fas fa-check"></i> <i>تایید شده</i> </span>
                        <span v-if="item.zamenIsTaeed1 == 2" class="badge badge-danger"> <i class="fas fa-times"></i> <i>رد شده </i> </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.zamenName2 != null" class="col-12 col-md-4 border-right border-info">
                    <div v-if="item.zamenName2 == null" class="row">
                      <span class="font-weight-bold"> برای ضامن دوم اطلاعاتی وارد نشده است</span>
                    </div>
                    <div v-else class="row">
                      <div class="col-12 col-md-2" v-if="$session.get('CustCode') == '259' || $session.get('CustCode') == '8002'">
                        <i
                          class="fa fa-pen fa-2x mt-2 hover-dark Pointer text-secondary"
                          title="ویرایش ضامن دوم"
                          @click="EditZamen(4032, item.id, item.zamenName2, item.isModirTaeed, item.zamenIsTaeed2)"
                        ></i>
                      </div>
                      <div class="col-12 col-md-10">
                        <div class="mb-1">
                          <span class="text-secondary"> مشخصات ضامن دوم: </span>
                          <span>{{ item.zamenName2 }}</span>
                        </div>
                        <span class="text-secondary">وضعیت تایید: </span>
                        <span v-if="item.zamenIsTaeed2 == 0" class="badge badge-warning"> <i class="far fa-hourglass"></i> <i>در حال بررسی </i> </span>
                        <span v-if="item.zamenIsTaeed2 == 1" class="badge badge-success"> <i class="fas fa-check"></i> <i>تایید شده</i> </span>
                        <span v-if="item.zamenIsTaeed2 == 2" class="badge badge-danger"> <i class="fas fa-times"></i> <i>رد شده </i> </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.zamenName3 != null" class="col-12 col-md-4 border-right border-info">
                    <div v-if="item.zamenName3 == null" class="row">
                      <span class="font-weight-bold"> برای ضامن سوم اطلاعاتی وارد نشده است</span>
                    </div>
                    <div v-else class="row">
                      <div class="col-12 col-md-2" v-if="$session.get('CustCode') == '259' || $session.get('CustCode') == '8002'">
                        <i
                          class="fa fa-pen fa-2x mt-2 hover-dark Pointer text-secondary"
                          title="ویرایش ضامن سوم"
                          @click="EditZamen(4033, item.id, item.zamenName3, item.isModirTaeed, item.zamenIsTaeed3)"
                        ></i>
                      </div>
                      <div class="col-12 col-md-10">
                        <div class="mb-1">
                          <span class="text-secondary"> مشخصات ضامن سوم: </span>
                          <span>{{ item.zamenName3 }}</span>
                        </div>
                        <span class="text-secondary">وضعیت تایید: </span>
                        <span v-if="item.zamenIsTaeed3 == 0" class="badge badge-warning"> <i class="far fa-hourglass"></i> <i>در حال بررسی </i> </span>
                        <span v-if="item.zamenIsTaeed3 == 1" class="badge badge-success"> <i class="fas fa-check"></i> <i>تایید شده</i> </span>
                        <span v-if="item.zamenIsTaeed3 == 2" class="badge badge-danger"> <i class="fas fa-times"></i> <i>رد شده </i> </span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr v-if="item.zamenName1 != null || item.zamenName2 != null || item.zamenName3 != null" class="my-3" />
                <div class="row">
                  <div class="col-12">
                    <span class="text-secondary"> شرح اصلاحات توسط کارشناس {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }} : </span>
                    <span v-if="item.sharhEslahatByModir == null || item.sharhEslahatByModir == ''"> اصلاحی وجود ندارد </span>
                    <span v-else>
                      {{ item.sharhEslahatByModir }}
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </div>
          <div v-else class="row p-3">
            <div class="alert alert-warning col-12 bnp-rounded border Netpa-Shadow border-warning" style="height: 50vh">
              <span style="font-size: 14px !important; font-weight: bold"> درخواستی برای نمایش وجود ندارد </span>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="">
          <div class="btn-Close-Modal">
            <button type="button" id="CloseModal" class="close text-dark" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row p-2">
            <div class="col-12">
              <div class="alert alert-warning text-center">
                <div class="">کد ملی ضامن جدید را وارد و سپس روی دکمه بررسی کلیک کنید</div>
                <b class="text-danger">اطلاعات ضامن جدید جایگزین {{ OldZamen.OldZamenName }} می شود</b>
              </div>
            </div>
            <div class="col-1"></div>
            <div class="col-7 text-right">
              <input class="form-control text-center" placeholder="کد ملی ضامن" v-model="newCodemeli" />
            </div>
            <div class="col-3">
              <button class="btn btn-success w-100 h-100" @click="Estelam">استعلام</button>
            </div>
            <div class="col-1"></div>

            <div class="col-12" v-if="newZamenInfo != null">
              <div class="mt-2 text-center border rounded border-success py-2">
                <b class="text-dark font-weight-normal">اطلاعات ضامن : {{ newZamenInfo.nameFamily }} </b>
                <button class="btn btn-warning mr-5" @click="reject">حذف</button>
                <button class="btn btn-success mx-2" @click="addZamen">تایید</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>

<script>
import ModalCustom from "../Tools/ModalCustom.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
export default {
  components: { NetPaCard, ModalCustom },
  data() {
    return {
      loanFollowup: "loanFollowup",
      NeedVamList: [],
      newCodemeli: null,
      newZamenInfo: null,
      OldZamen: {},
      Render: 0,
    };
  },
  created() {},
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      var formdata = new FormData();
      formdata.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      var DataAxiosNeedVam = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "ListNeedVam",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosNeedVam).then((data) => {
        this.NeedVamList = data;
      });
    },
    dropdown(index) {
      if (document.getElementById("needBody" + index).classList.contains("NoShow")) {
        document.getElementById("needBody" + index).classList.remove("NoShow");
        document.getElementById("needBody" + index).classList.add("ShowNeed");
      } else {
        document.getElementById("needBody" + index).classList.remove("ShowNeed");
        document.getElementById("needBody" + index).classList.add("NoShow");
      }
    },
    EditZamen(ZamenNoId, NeedVamId, OldZamenName, IsModirTaeed, ZamenIsTaeed) {
      if (ZamenIsTaeed == 1) {
        this.$mySweetDefaultTost("خطا در ویرایش ضامن", "ضامن انتخابی درخواست ضمانت شمارا تایید کرده و امکان ویرایش این ضامن وجود ندارد ", "error", 2200);
        return;
      }
      if (IsModirTaeed != 0) {
        this.$mySweetDefaultTost("خطا در ویرایش ضامن", "به دلیل برسی توسط مدیر سامانه و تغییر در وضعیت درخواست امکان ویرایش ضامن وجود ندارد ", "error", 2200);
        return;
      }
      this.OldZamen = { NeedVamId: NeedVamId, ZamenNoId: ZamenNoId, OldZamenName: OldZamenName };
      document.getElementById("ShowModal").click();
    },
    Estelam() {
      if (this.$session.get("UserInfoNetPa").codeMeli.trim() == this.newCodemeli) {
        this.$mySweetDefault("خطا", "شما کد ملی خود را وارد کرده اید", "error", 2000);
        this.newCodemeli = null;
        return;
      }
      if (this.newCodemeli.trim().length < 10 || this.newCodemeli.trim().length > 10) {
        this.$mySweetDefault("خطا", " طول کد ملی نمیتواند کمتر یا بیشتر از 10 رقم باشد", "error", 2000);
        return;
      }
      var DataAxiosGetZament = {
        ArryfildValue: "",
        Method: "Post",
        Action: "GetZamenByMelli3Onlione",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("wwwtblShobeId", this.$session.get("UserInfoNetPa").wwwtblShobeId);
      formdata.append("CodeMeli", this.newCodemeli);
      DataAxiosGetZament.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosGetZament).then((res) => {
        this.newZamenInfo = res;
      });
    },
    reject() {
      this.newZamenInfo = null;
      this.newCodemeli = null;
    },
    addZamen() {
      var DataAxiosNewZament = {
        ArryfildValue: "",
        Method: "Post",
        Action: "UpdateZamenByMelli",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("NeedVamId", this.OldZamen.NeedVamId);
      formdata.append("tblComboIdNoe10", this.OldZamen.ZamenNoId);
      formdata.append("NewCodeMeli", this.newCodemeli);
      formdata.append("NewMobile", this.newZamenInfo.mobile);
      formdata.append("NewAzaId", this.newZamenInfo.id);
      formdata.append("NewNameFamily", this.newZamenInfo.nameFamily);
      DataAxiosNewZament.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosNewZament).then((res) => {
        if (res.status == "Ok") {
          this.GetData();
          document.getElementById("CloseModal").click();
          this.$mySweetDefault("عملیات موفق", "عملیات ویرایش ضامن با موفقیت انجام شد", "success", 2000);
          this.Render++;
        } else {
          this.GetData();
          document.getElementById("CloseModal").click();
          this.$mySweetDefault("عملیات ناموفق", " خطایی در ویرایش اطلاعات ضامن به  وجود آمد، لطفا دقایقی دیگر مجدد اقدام کنید", "error", 2000);
          this.Render++;
        }
      });
    },
  },
};
</script>
<style scoped>
.badge {
  font-weight: normal !important;
  font-size: 10px !important;
}
.NoShow {
  display: none !important;
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
  /* background: #d5d5d5; */
}
.ShowNeed {
  display: block !important;
  max-height: 100%;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}
</style>
